import { Injectable } from '@angular/core';
import { TileTypicalWeeksComponent } from '../../../components/tile/tile-typical-weeks/tile-typical-weeks';
import type { CustomTileModel } from '../../../interfaces/Tile.interface';
import type { CustomTileProvider } from './custom-tile.provider';

@Injectable({
    providedIn: 'root'
})
export class TileTypicalWeeksProvider implements CustomTileProvider {
    fillTileDescription(): CustomTileModel {
        throw Error('Not implemented');
    }

    getTileComponent() {
        return TileTypicalWeeksComponent;
    }
}
